export default __webpack_public_path__ + "static/media/Van14.2a1e4ea1.webp";